import styled from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

const IconTitleTextTooltipTextContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: column;

    ${({theme}) => theme.font.presets.bold};
    font-size: 12px;
 `;

const IconTitleTextTooltipTextContainerMrGreenBox = styled(IconTitleTextTooltipTextContainerDefaultBox)`
    color: ${({theme}) => theme.colors.brandSecondaryContrast};
    font-weight: 400;
 `;

export const IconTitleTextTooltipTextContainerBox = styledByTheme(IconTitleTextTooltipTextContainerDefaultBox)
    .forMrGreen(IconTitleTextTooltipTextContainerMrGreenBox)
    .apply();